import { Shape, ShapeCombo, ShapeComboOptions } from "../Shape";

export type ShipShapeComboOptions = {
  showFlame?: boolean;
} & ShapeComboOptions;

export class ShipShapeCombo extends ShapeCombo {
  protected showFlame: boolean;
  protected flame: Shape;
  protected ship: Shape;

  constructor(options?: ShipShapeComboOptions) {
    super(options);

    this.showFlame =
      typeof options?.showFlame == "boolean" ? options?.showFlame : true;

    this.flame = new Shape({
      initD: [["M", -15, 0], ["L", -2.5, -5], ["L", -2.5, 5], ["Z"]],
      drag: {
        followSibling: true
      }
    });
    if (this.showFlame) {
      this.addShape(this.flame);
    }

    this.ship = new Shape({
      initD: [
        ["M", 10, 0],
        ["L", -10, 10],
        ["L", -5, 0],
        ["L", -10, -10],
        ["L", 10, 0],
        ["Z"]
      ],
      drag: {
        followSibling: true
      }
    });
    this.addShape(this.ship);
  }

  protected cloneShapeCombo(): ShipShapeCombo {
    const shapeCombo = new ShipShapeCombo({
      ...super.getBaseOptions(),
      showFlame: this.showFlame
    });
    return shapeCombo;
  }

  // 供外部使用：基本属性变更
  public update(options: ShipShapeComboOptions) {
    if (typeof options?.showFlame == "boolean") {
      this.shapes = [];
      this.showFlame = options?.showFlame;
      if (this.showFlame) {
        this.addShape(this.flame);
      }
      this.addShape(this.ship);
    }
  }
}

export default ShipShapeCombo;
